import { usePromotionQuery } from 'hooks'
import { useRouter } from 'next/router'
import { FormProviders } from 'ui'
import { ErrorPage } from 'ui/components/ErrorPage'
import { PromotionForm } from '../src/components/Form'
import { Loading } from '../src/components/Form/Loading'
import { mapPromotion } from '../src/components/Form/mappers/fromAPI'
import {
  LegacyRedirectWrapper,
  PROMOTION_FORM,
} from '../src/components/LegacyRedirectWrapper'

export default function EditionForm() {
  const router = useRouter()
  const id = router.query.id as string
  const { data, isLoading, isError } = usePromotionQuery({ id })

  if (isError) return <ErrorPage />

  if (isLoading || !data) return <Loading />

  return (
    <LegacyRedirectWrapper promoId={id} to={PROMOTION_FORM} type={data.type}>
      {() => (
        <FormProviders>
          <PromotionForm promotion={mapPromotion(data)} originalValues={data} />
        </FormProviders>
      )}
    </LegacyRedirectWrapper>
  )
}
